import { useContext } from 'react'
import { WorkoutTemplateBuilderContext } from '../../WorkoutTemplateBuilder'

export default function AddPhaseButton() {
    const { mode, mutatePhase } = useContext(WorkoutTemplateBuilderContext)

    if (mode === 'edit') {
        return (
            <button type="button" className="w-full rounded-lg bg-white py-1 text-sm text-gray-900 ring-1 ring-inset ring-stone-400 hover:bg-stone-100" onClick={() => mutatePhase('add-phase')}>
                + Add Phase
            </button>
        )
    }
}
